/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { autorun, reaction } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import {
  Segment, Dimmer, Loader, Label, Icon, List, Table, Pagination, Input, Modal, Message
} from 'semantic-ui-react';
import cx from 'classnames';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import PatchVerisonModal from '../Modal/PatchVersionModal';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';
import WithRouter from '../Extensions/WithRouter';
import RenderProjectTree from '../Extensions/RenderProjectTree';
import SecurityRow from './SecurityRow';
import CvssDisplay from './CvssDisplay';

class SecurityDetail extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.viewRef = React.createRef();
    this.securityFileDetail = React.createRef();
    this.state = {
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      securityFileList: [],
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      isOpenMPV: false,
      selectedCveCode: null,
      selectedComponentList: [],
      hasMore: false,
      activeIndex: [],
      popupIndex: [],
      securityTreeData: [],
      filter: ['status_v'],
      searchKeyword: '',
      isSort: false,
      popupType: '',
      sortValue: '2',
      idReport: this.props.params.idReport,
      isOpenMSF: false,
      scannedFileIds: [],
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
      isOnline: navigator.onLine,
      cvssPopupKey: 0,
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.disposeSecurityFileListReaction = reaction(
      () => { return state.user.currentPrecisionLevel; },
      (currentPrecisionLevel) => {
        if (currentPrecisionLevel !== null && this.securityFileDetail) {
          this.getSecurityfileList();
        }
      },
      {
        fireImmediately: true
      }
    );

    this.renderPopup();
    document.addEventListener('mousedown', this.handleClickOutside);
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;

    if (prevProps.params.idReport !== params.idReport) {
      this.setState(
        {
          idReport: params.idReport,
          securityFileList: [],
        },
        () => {
          this.getSecurityfileList();
        }
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);

    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
    if (this.disposeSecurityFileListReaction) {
      this.disposeSecurityFileListReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        securityFileList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getSecurityfileList(activePage, pageSize);
      });
    }
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleOnScroll = () => {
    const {
      getSecurityfileList,
      state: {
        error, isLoading, hasMore, viewMode
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getSecurityfileList(this.state.currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        securityFileList: [],
        activeIndex: [],
      },
      () => {
        this.getSecurityfileList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        securityFileList: [],
        activeIndex: [],
        filter: value.filter,
      },
      () => {
        this.getSecurityfileList();
      }
    );
  };

  handleMoreInfo = (index, type) => {
    const { popupIndex, cvssPopupKey } = this.state;
    let newState;
    let newKey = cvssPopupKey;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    if (type === 'type_0') {
      newKey += 1;
    }

    this.setState({
      popupIndex: newState,
      popupType: type,
      cvssPopupKey: newKey,
    });
  };

  handleOtherRisk = (index, ids) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState(
      {
        popupIndex: newState,
        popupType: 'type_1',
      },
      () => {
        this.getProjectTree(ids);
      }
    );
  };

  handlePopupClose = (index) => {
    const { popupIndex } = this.state;
    const newState = popupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      popupIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside = (event) => {
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (this.state.popupIndex.length !== 0 && this.state.popupType !== '') {
        this.setState({
          popupIndex: '',
          popupType: '',
        });
        return true;
      }
      return false;
    }
  };

  handlePatchVersionModal = (index, cveCode) => {
    const { securityFileList } = this.state;
    const componentList = Object.keys(securityFileList[index].securityFileDetail.securities).map((item) => {
      return {
        component_name: item,
        children: [],
      };
    });

    this.setState({
      selectedCveCode: cveCode,
      isOpenMPV: true,
      selectedComponentList: componentList,
    });
  };

  handleMSFClose = () => {
    this.setState({
      isOpenMSF: false,
    });
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        securityFileList: [],
        activeIndex: [],
      },
      () => {
        this.getSecurityfileList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      securityFileList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getSecurityfileList(activePage, pageSize);
    });
  };

  handleNavigateToNvd = (cveCode) => {
    const { isOnline } = this.state;
    if (isOnline) {
      const match = cveCode.match(/CVE-\d{4}-\d{4,7}/);
      const extractedCveCode = match ? match[0] : '';

      if (extractedCveCode) {
        window.open(`https://nvd.nist.gov/vuln/detail/${extractedCveCode}`, '_blank');
      } else {
        console.error('Invalid CVE code');
      }
    }
  };

  onChangeSorting = (e) => {
    const { isSort } = this.state;

    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          securityFileList: [],
          activeIndex: [],
        },
        () => {
          this.getSecurityfileList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          securityFileList: [],
          activeIndex: [],
        },
        () => {
          this.getSecurityfileList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    const { state } = this.props;
    this.setState({
      securityFileList: [],
      activeIndex: [],
    }, () => {
      state.user.setPrecisionLevel(value);
    });
  };

  getSecurityfileList = (pageNo, limit) => {
    let text;
    let filterData;
    let precisionLevel;

    const {
      isSort, sortValue, securityFileList, pageSize, filter
    } = this.state;
    const { state, t } = this.props;
    const userStore = { ...state.user };

    const page = pageNo || 1;
    let perPage = limit || pageSize;

    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }

    if (userStore.currentPrecisionLevel) {
      precisionLevel = userStore.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
    } else {
      filterData = '';
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'security_name_r';
      } else {
        text = 'security_name';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'risk_r';
      } else {
        text = 'risk';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'component_count_r';
      } else {
        text = 'component_count';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'component_version_count_r';
      } else {
        text = 'component_version_count';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'scanned_file_count_r';
      } else {
        text = 'scanned_file_count';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'status';
      } else {
        text = 'status_r';
      }
      break;
    default:
      text = 'risk';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getSecurityfileList(
            {
              search: this.state.searchKeyword,
              filter: filterData,
              page,
              limit: perPage,
              order: text,
              precision_level: precisionLevel,
            },
            this.state.idReport
          )
          .then((response) => {
            if (this.state.securityFileList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextSecurityFileList = response.response.map((item) => {
              return {
                uploadedFileId: item.uploaded_file_id,
                codeName: item.code,
                riskGrade: item.risk.toLowerCase(),
                componentCount: item.component_count,
                componentVersionCount: item.component_version_count,
                scannedFileCount: item.scanned_file_count,
                isExploit: item.is_exploit,
                status: item.status,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              securityFileList: [...securityFileList, ...nextSecurityFileList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getSecurityFileDetail = (securityName) => {
    const { t } = this.props;
    let precisionLevel;

    if (this.props.state.user.currentPrecisionLevel) {
      precisionLevel = this.props.state.user.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    this.setState({
      isDetailLoading: true,
      isVisible: securityName,
    }, () => {
      api
        .getSecurityFileDetail(
          {
            security_name: securityName,
            precision_level: precisionLevel,
          },
          this.state.idReport
        )
        .then((response) => {
          const { securityFileList } = this.state;
          const data = response.response;
          const updatedIndex = securityFileList.findIndex((item) => {
            return item.codeName === securityName;
          });
          const updatedData = Update(securityFileList[updatedIndex], {
            securityFileDetail: { $set: data },
          });
          const newData = Update(securityFileList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            securityFileList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  getProjectTree = (ufid) => {
    const { t } = this.props;
    const value = JSON.parse(`[${ufid}]`);
    const obj = {
      uploaded_file_ids: value,
    };
    api
      .getProjectTree(obj)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
        });
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 15) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 14 && tableEl.length > 15) || (i > 15 && (i - 14) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, codeName) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getSecurityFileDetail(codeName);
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      securityFileList: [],
      activeIndex: [],
    }, () => {
      this.getSecurityfileList();
    });
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        securityFileList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getSecurityfileList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        securityFileList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getSecurityfileList();
      }
    );
  };

  closePatchVersionModal = () => {
    this.setState({
      selectedCveCode: null,
      isOpenMPV: false,
      selectedComponentList: [],
    });
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        securityFileList: [],
        activeIndex: [],
      },
      () => {
        this.getSecurityfileList();
      }
    );
  };

  /*
  updateOnlineStatus() {
    this.setState({ isOnline: navigator.onLine });
  }
  */

  renderValue = () => {
    const { filter } = this.state;
    const { t } = this.props;

    const securityFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });

    const statusFilter = filter.filter((item) => {
      return item.indexOf('status') > -1;
    });

    const filterObj = { security: securityFilter, status: statusFilter };

    return (
      <div>
        {filterObj.security.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.link_header.security_risks')}</strong>
            </span>
            {filterObj.security.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && 'Critical'}
                  {item.indexOf('_h') > -1 && 'High'}
                  {item.indexOf('_m') > -1 && 'Medium'}
                  {item.indexOf('_l') > -1 && 'Low'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.status.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('list.title.status')}</strong>
            </span>
            {filterObj.status.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_v') > -1 && 'Vulnerable'}
                  {item.indexOf('_f') > -1 && 'Fixed'}
                  {item.indexOf('_n') > -1 && 'Not Affected'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderPopup = () => {
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.card_detail_popup .table_type_1 .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  };

  renderReference = (source, desc, url, tags) => {
    const { t } = this.props;
    const refDatas = Object.assign(source.map((k, i) => {
      return {
        key: k || null,
        url: url ? url[i] : null,
        tag: tags ? tags[i] : null,
      };
    }));

    return (
      <Table
        className="reference"
        celled
        padded
        fixed
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2}>{t('modal.title.source')}</Table.HeaderCell>
            <Table.HeaderCell width={3}>{t('modal.title.tag')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            refDatas.map((item) => {
              return (
                <Table.Row key={uuidv4()}>
                  <Table.Cell
                    title={[item.key || null].join('')}
                    verticalAlign="middle"
                  >
                    {item.key || null}
                  </Table.Cell>
                  <Table.Cell
                    title={[item.tag || null].join('')}
                    verticalAlign="top"
                  >
                    {item.tag ? item.tag.map((nest, idx) => {
                      if (idx === 0) {
                        return (
                          <div key={uuidv4()}>
                            {nest}
                            <br />
                          </div>
                        );
                      }
                      return (
                        <div key={uuidv4()} style={{ marginTop: '1px' }}>
                          {nest}
                          <br />
                        </div>
                      );
                    }) : null}
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  };

  renderVulnPkg = (array) => {
    let nextCIndex;
    let nextWIndex;
    let wIndex;
    let isStartTab = false;
    const cIndexTotal = [];
    const wIndexTotal = [];

    if (!array) {
      return;
    }
    array.findIndex((o, index) => {
      if (o.indexOf('Configuration') > -1) {
        cIndexTotal.push(index);
      }
      if (o.indexOf('With') > -1) {
        wIndexTotal.push(index);
      }
      return null;
    });

    const result = array.map(
      (vuln, idx) => {
        if (wIndexTotal.length !== 0 && wIndexTotal.indexOf(idx) > -1) {
          isStartTab = true;
        }

        if (cIndexTotal.length !== 0 && cIndexTotal.indexOf(idx) > -1) {
          isStartTab = false;
        }

        if (vuln.indexOf('Configuration') > -1) {
          const currentIndex = cIndexTotal.findIndex((o) => {
            return o === idx;
          });
          nextCIndex = cIndexTotal[currentIndex + 1];

          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 0',
                  border: 0,
                  fontWeight: 'bold',
                  background: '#f7f7f7',
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        if (vuln.indexOf('With') > -1) {
          wIndex = idx;
          const currentIndex = wIndexTotal.findIndex((o) => {
            return o === idx;
          });
          nextWIndex = wIndexTotal[currentIndex + 1];
          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 10px',
                  border: 0,
                  fontWeight: 'bold'
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        if (wIndex && nextWIndex && nextCIndex && wIndex < idx < nextWIndex && idx < nextCIndex && isStartTab) {
          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 20px',
                  border: 0,
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        return (
          <tr key={uuidv4()}>
            <td
              style={{
                fontSize: '13px',
                wordBreak: 'break-all',
                padding: '5px 0 5px 10px',
                border: 0,
              }}
            >
              {vuln}
            </td>
          </tr>
        );
      }
    );
    return result;
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      securityFileList,
      activeIndex,
      securityTreeData,
      isSort,
      sortValue,
      filter,
      popupType,
      popupIndex,
      isDetailLoading,
      isVisible,
      isOpenMPV,
      selectedCveCode,
      selectedComponentList,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      searchKeyword,
      totalCount,
      isOnline,
      cvssPopupKey
    } = this.state;

    const {
      location, state, params, t, navigate
    } = this.props;

    return (
      <div
        className="result_file"
        ref={this.securityFileDetail}

      >
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          totalCount={totalCount}
          handlePrecisionLevel={this.setPrecisionLevel}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
        />
        <div className="content">
          {filter.length !== 0 ? <div className="tag_list">{this.renderValue()}</div> : null}
          <div className="wide_card_wrap">
            <div className="table_header">
              <div className="table_header_inner">
                <table className="wide_card_table wide_card_scope">
                  <colgroup>
                    <col style={{ width: '3.9%', maxWidth: '36px' }} />
                    <col style={{ width: '13%', maxWidth: '120px' }} />
                    <col style={{ width: '9.1%', maxWidth: '84px' }} />
                    <col style={{ width: '19%' }} />
                    <col style={{ width: '19%' }} />
                    <col style={{ width: '19%' }} />
                    <col style={{ width: '12.6%' }} />
                    <col style={{ width: '4.3%', maxWidth: '40px' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="checkbox_wrap tal">
                        <div className="checkbox" />
                      </th>
                      <th className="tac">
                        <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                          {t('modal.title.cve_code')}
                          {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a className="sorting_button" data-id="2" onClick={this.onChangeSorting}>
                          {t('chart.title.severity')}
                          {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                          {t('list.title.component')}
                          {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                          {t('list.title.component_version')}
                          {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a className="sorting_button" data-id="5" onClick={this.onChangeSorting}>
                          {t('contents_header.place_holder.scanned_file_name')}
                          {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a className="sorting_button" data-id="6" onClick={this.onChangeSorting}>
                          {t('list.title.status')}
                          {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {securityFileList.map((item, index) => {
              return (
                <div
                  className={cx(
                    'wide_card_box wide_card_type_03',
                    {
                      expand: activeIndex.indexOf(index) >= 0,
                    },
                    {
                      card_detail_popup_show: popupIndex.indexOf(index) >= 0,
                    },
                    {
                      type_0: popupType === 'type_0',
                    },
                    {
                      type_1: popupType === 'type_1',
                    },
                    {
                      type_2: popupType === 'type_2',
                    },
                    {
                      red: item.riskGrade === 'critical'
                    },
                    {
                      orange: item.riskGrade === 'high'
                    },
                    {
                      cheese: item.riskGrade === 'medium'
                    },
                    {
                      yellow: item.riskGrade === 'low'
                    }
                  )}
                  key={item.codeName.toString()}
                >
                  <table className="wide_card_table wide_card_item">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '9.1%', maxWidth: '84px' }} />
                      <col style={{ width: '19%' }} />
                      <col style={{ width: '19%' }} />
                      <col style={{ width: '19%' }} />
                      <col style={{ width: '12.6%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr
                        className="sum_line"
                        onClick={() => {
                          return this.toggleRow(index, item.codeName);
                        }}
                      >
                        <td className="checkbox_wrap border-none tal">
                          <div className="checkbox" />
                        </td>
                        <td className="border-none tac">
                          <strong>{item.codeName}</strong>
                          {item.isExploit ? (<Icon name="bug" />) : null}
                        </td>
                        <td className="border-none tac">{item.riskGrade}</td>
                        <td className="sum_td" colSpan="3">
                          <table className="wide_card_table wide_card_item">
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td className="tac">{item.componentCount}</td>
                                <td className="tac">{item.componentVersionCount}</td>
                                <td className="tac">{item.scannedFileCount}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td className="border-none tac">{t(`list.title.${item.status}`)}</td>
                        <td className="border-none tac">
                          <a
                            className="expand_button"
                          >
                            <img src={expandBtn} alt="" />
                          </a>
                        </td>
                      </tr>
                      {
                        isDetailLoading && isVisible === item.codeName ? (
                          <tr>
                            <td className="border-none" colSpan="8">
                              <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                <Loader active={isDetailLoading && isVisible === item.codeName} inline="centered" />
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <tr className="extend_item">
                            <td className="checkbox_wrap border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none sum_td" colSpan="4">
                              {
                                item.securityFileDetail
                                && (
                                  <SecurityRow
                                    childRef={this.viewRef}
                                    rowData={item.securityFileDetail}
                                    uid={item.uploadedFileId}
                                    t={t}
                                    state={state}
                                    location={location}
                                    params={params}
                                  />
                                )
                              }
                            </td>
                            <td className="border-none tal">&nbsp;</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                  {item.securityFileDetail ? (
                    <div className="wide_card_detail">
                      <div className="wide_card_detail_top type_description" style={{ height: '232px', position: 'relative' }}>
                        <div className="foo" style={{ marginTop: '18px', position: 'absolute', bottom: '0' }}>
                          {item.securityFileDetail.cvss_version === '2.0' && 'CVSS v2 Base Score'}
                          {item.securityFileDetail.cvss_version === '3.0' && 'CVSS v3 Base Score'}
                          {item.securityFileDetail.cvss_version === '4.0' && 'CVSS v4 Base Score'}
                        </div>
                        <div className="version_text" style={{ position: 'absolute', bottom: '3px', right: '5px' }}>{item.securityFileDetail.score}</div>
                      </div>
                      <div className="wide_card_detail_bottom">
                        <a
                          className={cx('card_detail_popup_show', {
                            active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                          })}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return this.handleMoreInfo(index, 'type_0');
                          }}
                        >
                          {t('list.title.more_information')}
                        </a>
                        {
                          item.securityFileDetail.patch_info.length !== 0 ? (
                            <a
                              className={cx('card_detail_popup_show', {
                                active: popupIndex.indexOf(index) >= 0 && popupType === 'type_2',
                              })}
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handleMoreInfo(index, 'type_2');
                              }}
                            >
                              {t('list.title.patch_information')}
                            </a>
                          ) : null
                        }
                        <a
                          className="card_detail_popup_show"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return this.handlePatchVersionModal(index, item.codeName);
                          }}
                        >
                          {t('list.title.patch_versions')}
                        </a>
                        <a
                          className={cx('card_detail_popup_show', {
                            active: popupIndex.indexOf(index) >= 0 && popupType === 'type_1',
                          })}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return this.handleOtherRisk(
                              index,
                              item.securityFileDetail.uploaded_file_ids
                            );
                          }}
                        >
                          {t('list.title.other_file_risk')}
                        </a>
                      </div>
                    </div>
                  ) : null}
                  {item.securityFileDetail && popupType === 'type_0' && (
                    <div className="card_detail_popup card_detail_popup_1 security">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          {t('list.title.more_information')}
                          {item.securityFileDetail.more_info && (
                            <span>
                              {' - '}
                              <a
                                className={cx(
                                  'nvd_link',
                                  {
                                    online: isOnline,
                                  }
                                )}
                                onClick={isOnline ? () => { return this.handleNavigateToNvd(item.securityFileDetail.more_info.cve); } : null}
                                onKeyUp={isOnline ? () => { return this.handleNavigateToNvd(item.securityFileDetail.more_info.cve); } : null}
                              >
                                {item.securityFileDetail.more_info.cve}
                              </a>
                            </span>
                          )}
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <div className="type_3 ">
                              <Message header={t('list.title.description')} content={item.securityFileDetail.description} />
                              <CvssDisplay
                                key={cvssPopupKey}
                                securityInfo={item.securityFileDetail.more_info}
                                translate={t}
                              />
                              {
                                item.securityFileDetail.more_info.rejected ? (
                                  <dl>
                                    <dt>{t('modal.cve.rejected')}</dt>
                                    <dd style={{ color: '#912d2b' }}>{item.securityFileDetail.more_info.rejected}</dd>
                                  </dl>
                                ) : null
                              }
                              <dl>
                                <dt>{t('modal.cve.common_weakness_enumeration')}</dt>
                                <dd>{item.securityFileDetail.more_info.type}</dd>
                              </dl>
                              <dl>
                                <dt>{t('modal.cve.published_date')}</dt>
                                <dd>{item.securityFileDetail.more_info.pdate}</dd>
                              </dl>
                              <dl>
                                <dt>{t('modal.cve.last_modified_date')}</dt>
                                <dd>{item.securityFileDetail.more_info.mdate}</dd>
                              </dl>
                              {
                                item.securityFileDetail.more_info.refsource.length !== 0 ? (
                                  <dl>
                                    <dt>{t('modal.cve.references')}</dt>
                                    {this.renderReference(item.securityFileDetail.more_info.refsource, item.securityFileDetail.more_info.refdescription, item.securityFileDetail.more_info.web_site, item.securityFileDetail.more_info.reftags)}
                                  </dl>
                                ) : null
                              }
                              {
                                item.securityFileDetail.patch_info && item.securityFileDetail.patch_info.length !== 0 ? (
                                  <dl>
                                    <dt>{t('modal.cve.pathc_url')}</dt>
                                    <List>
                                      {item.securityFileDetail.patch_info.map((url) => {
                                        return (
                                          <List.Item className="patch_url" key={uuidv4()}>
                                            <List.Content>
                                              <a href={url} target="_blank" rel="noopener noreferrer">
                                                {url}
                                              </a>
                                            </List.Content>
                                          </List.Item>
                                        );
                                      })}
                                    </List>
                                  </dl>
                                ) : null
                              }
                              <div className="line" />
                              <dl>
                                <dt>{t('modal.cve.vulnerable_packages')}</dt>
                              </dl>
                              {item.securityFileDetail.more_info.vuln_sw.length !== 0 ? (
                                <table className="table_type_2">
                                  <tbody>
                                    {this.renderVulnPkg(item.securityFileDetail.more_info.vuln_sw)}
                                  </tbody>
                                </table>
                              ) : null}
                            </div>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  )}
                  {securityTreeData.length !== 0 && popupType === 'type_1' && (
                    <div className="card_detail_popup card_detail_popup_2">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <RenderProjectTree
                              treeData={securityTreeData}
                              translate={t}
                              tableType={false}
                              state={state}
                            />
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  )}
                  {item.securityFileDetail && popupType === 'type_2' && (
                    <div className="card_detail_popup card_detail_popup_3">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          {t('list.title.patch_information')}
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <div className="type_3">
                              {
                                item.securityFileDetail.patch_info && item.securityFileDetail.patch_info.length !== 0 ? (
                                  <dl>
                                    <dt>{t('modal.cve.pathc_url')}</dt>
                                    <List>
                                      {item.securityFileDetail.patch_info.map((url) => {
                                        return (
                                          <List.Item className="patch_url" key={uuidv4()}>
                                            <List.Content>
                                              <a href={url} target="_blank" rel="noopener noreferrer">
                                                {url}
                                              </a>
                                            </List.Content>
                                          </List.Item>
                                        );
                                      })}
                                    </List>
                                  </dl>
                                ) : null
                              }
                            </div>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {error && <div className="error_log">{error}</div>}
            {isLoading && (
              <Segment>
                <Dimmer active inverted>
                  <Loader size="medium" style={{ lineHeight: '15px' }}>{t('modal.message.loading')}</Loader>
                </Dimmer>
              </Segment>
            )}
            {
              viewMode === 'list' && securityFileList.length !== 0
              && (
                <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                  <Pagination
                    activePage={currentPage}
                    totalPages={totalPage}
                    onPageChange={this.handlePaginationChange}
                    //size="mini"
                    ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                    firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                    lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                    prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                    nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                  />
                  <div className="active_page">
                    <Input
                      type="number"
                      label={t('list.title.active_page')}
                      min={1}
                      value={activePage}
                      onChange={this.handleInputActivePageChange}
                      onKeyPress={this.handleActivePageChange}
                    />
                  </div>
                </div>
              )
            }
            {!hasMore && <Footer />}
          </div>
        </div>
        <PatchVerisonModal
          isOpenMPV={isOpenMPV}
          cveCode={selectedCveCode}
          componentList={selectedComponentList}
          closeModal={this.closePatchVersionModal}
          translate={t}
        />
        <ScannedFilesInfoModal
          isOpenMSF={this.state.isOpenMSF}
          closeModal={this.handleMSFClose}
          ufid={this.state.idReport}
          scannedFileIds={this.state.scannedFileIds}
          translate={t}
        />
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(SecurityDetail))));
